import { useMediaQuery } from "react-responsive";

import { QUERY_WIDTHS } from "@utils/index";
import { TransactionModel } from "@interfaces/index";
import {
  TableTdMobileTransaction,
  TableTdDesktopTransaction,
} from "@components/index";

export const TableRowTransaction = ({
  transaction,
  hideAssetColumn = false,
  onDetails,
  onRemove,
}: {
  transaction: TransactionModel;
  hideAssetColumn?: boolean;
  onDetails?: () => void;
  onRemove?: (id: string) => void;
}) => {
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });

  return isMobile ? (
    <TableTdMobileTransaction
      transaction={transaction}
      hideAssetColumn={hideAssetColumn}
      onClickRow={onDetails}
    />
  ) : (
    <TableTdDesktopTransaction
      transaction={transaction}
      hideAssetColumn={hideAssetColumn}
      onClickRow={onDetails}
      onRemove={onRemove}
    />
  );
};
